import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeSupplierQuotationCreate,
  detail: routeSupplierQuotationDetail,
  home: routeSupplierQuotationsHome,
  root: routeSupplierQuotationsRoot,
} = createDoctypeRoutes({
  createName: 'new-supplier-quotation',
  createPath: 'new-supplier-quotation',
  detailName: 'supplier-quotation-detail',
  doctype: DOCTYPES.SUPPLIER_QUOTATION,
  homeName: 'supplier-quotations-home',
  ifOwner: false,
  path: 'supplier-quotations',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/supplierQuotation/AddSupplierQuotation.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/supplierQuotation/ViewSupplierQuotation.vue'),
    list: async () =>
      await import('@/components/viewsExternal/supplierQuotation/SupplierQuotationView.vue'),
  },
})

export {
  routeSupplierQuotationCreate,
  routeSupplierQuotationDetail,
  routeSupplierQuotationsHome,
  routeSupplierQuotationsRoot,
}
